<div class="feedback" [class.disabled]="disabled">
  <div class="line"></div>
  <div class="choices" role="radiogroup">
    <ng-container *ngFor="let option of options">
      <div class="horizontal-radio-option" (click)="selectValue(option, $event)" [class.selected]="isSelected(option)">
        <label class="horizontal-radio-option-label">
          <div
            [attr.tabindex]="disabled ? null : 0"
            role="radio"
            class="horizontal-radio-button"
            [attr.aria-label]="option"
            [attr.aria-checked]="isSelected(option)"
            (keydown.space)="selectValue(option, $event)"
          >
            <div class="horizontal-outer-circle"></div>
          </div>
          <div class="horizontal-radio-label">{{ option }}</div>
        </label>
      </div>
    </ng-container>
  </div>
</div>
